import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { checkIsLoading } from 'common/utils/checkLoading';

import { RootState } from 'store';

import { CARDS_STATE } from '../../constants';
import { EMPTY_ARRAY } from 'shared/constants';

export const useActiveCards = () => {
  const activeCards = useSelector((state: RootState) => state[CARDS_STATE].activeCards.data);
  return activeCards;
};

export const useActiveCardList = () => {
  const activeCards = useActiveCards() || EMPTY_ARRAY;

  const activeCardList = useMemo(() => activeCards.map(activeCard => ({
    key: activeCard.fullCardNumber,
    value: activeCard.fullCardNumber,
    metadata: activeCard
  })), [activeCards]);

  return activeCardList;
};

const useActiveCardsLoadingCards = () => {
  const activeCardsLoadingCards = useSelector((state: RootState) => state[CARDS_STATE].activeCards.loadingStatus);
  return activeCardsLoadingCards;
};

export const useIsActiveCardsLoading = () => {
  const activeCardsLoadingCards = useActiveCardsLoadingCards();
  return checkIsLoading(activeCardsLoadingCards);
};
